import {
  Box,
  Flex,
  Image,
  Heading,
  Text,
  Icon,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import Images from "./Images.jsx";
import { FaTwitter, FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <Box
      bg="brand.900"
      color="white"
      backgroundSize="cover"
      backgroundImage={`url(${Images.PatternBackground})`}
    >
      <Flex
        py="2rem"
        px={{ base: ".5rem", lg: "2rem" }}
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Flex
          justifyContent={{ base: "center", lg: "flex-start" }}
          flexDirection="column"
          m="2rem"
          textAlign="center"
        >
          <Image
            maxWidth="300px"
            margin="0 auto"
            src={Images.PromiseCardLogoWhite}
            alt="Promise Card"
          />

          <Heading size="xl" fontWeight="600">
            PromiseCard
          </Heading>
          <Text>make a wish</Text>
        </Flex>

        <Box m="2rem">
          <Heading mb=".5rem" size="md">
            Company
          </Heading>
          <UnorderedList ml={0} spacing="4" styleType="none">
            <ListItem>About Us</ListItem>
            <ListItem>Terms of Use</ListItem>
            <ListItem>Privacy Policy</ListItem>
            <ListItem>FAQs</ListItem>
          </UnorderedList>
        </Box>

        <Box m="2rem">
          <Heading mb=".5rem" size="md">
            Get in Touch
          </Heading>
          <UnorderedList ml={0} spacing="4" styleType="none">
            <ListItem>MON - FRI, 8:00-22:00</ListItem>

            <ListItem>PROMISECARDNG@GMAIL.COM</ListItem>
            <ListItem>
              <Flex align="center">
                <Link to="#">
                  <Icon w={6} h={6} mx="1rem" as={FaTwitter} />
                </Link>
                <Link to="#">
                  <Icon w={6} h={6} mx="1rem" as={FaFacebook} />
                </Link>
                <Link to="#">
                  <Icon w={6} h={6} mx="1rem" as={FaLinkedin} />
                </Link>
                <Link to="#">
                  <Icon w={6} h={6} mx="1rem" as={FaInstagram} />
                </Link>
              </Flex>
            </ListItem>
          </UnorderedList>
        </Box>
      </Flex>

      <hr />
      <Text py="2rem" textAlign="center">
        &copy; PromiseCard {new Date().getFullYear()}
      </Text>
    </Box>
  );
}

export default Footer;
